// schemas/versioned.ts
import * as bare2 from "@rivetkit/bare-ts";
import { createVersionedDataHandler } from "vbare";

// dist/schemas/v1.ts
import * as bare from "@rivetkit/bare-ts";
var config = /* @__PURE__ */ bare.Config({});
function readCbor(bc) {
  return bare.readData(bc);
}
function writeCbor(bc, x) {
  bare.writeData(bc, x);
}
function readTraceId(bc) {
  return bare.readData(bc);
}
function writeTraceId(bc, x) {
  bare.writeData(bc, x);
}
function readSpanId(bc) {
  return bare.readData(bc);
}
function writeSpanId(bc, x) {
  bare.writeData(bc, x);
}
function readStringId(bc) {
  return bare.readU32(bc);
}
function writeStringId(bc, x) {
  bare.writeU32(bc, x);
}
function readKeyValue(bc) {
  return {
    key: readStringId(bc),
    value: readCbor(bc)
  };
}
function writeKeyValue(bc, x) {
  writeStringId(bc, x.key);
  writeCbor(bc, x.value);
}
function readAttributes(bc) {
  const len = bare.readUintSafe(bc);
  if (len === 0) {
    return [];
  }
  const result = [readKeyValue(bc)];
  for (let i = 1; i < len; i++) {
    result[i] = readKeyValue(bc);
  }
  return result;
}
function writeAttributes(bc, x) {
  bare.writeUintSafe(bc, x.length);
  for (let i = 0; i < x.length; i++) {
    writeKeyValue(bc, x[i]);
  }
}
function readSpanStatusCode(bc) {
  const offset = bc.offset;
  const tag = bare.readU8(bc);
  switch (tag) {
    case 0:
      return "UNSET" /* UNSET */;
    case 1:
      return "OK" /* OK */;
    case 2:
      return "ERROR" /* ERROR */;
    default: {
      bc.offset = offset;
      throw new bare.BareError(offset, "invalid tag");
    }
  }
}
function writeSpanStatusCode(bc, x) {
  switch (x) {
    case "UNSET" /* UNSET */: {
      bare.writeU8(bc, 0);
      break;
    }
    case "OK" /* OK */: {
      bare.writeU8(bc, 1);
      break;
    }
    case "ERROR" /* ERROR */: {
      bare.writeU8(bc, 2);
      break;
    }
  }
}
function read0(bc) {
  return bare.readBool(bc) ? bare.readString(bc) : null;
}
function write0(bc, x) {
  bare.writeBool(bc, x !== null);
  if (x !== null) {
    bare.writeString(bc, x);
  }
}
function readSpanStatus(bc) {
  return {
    code: readSpanStatusCode(bc),
    message: read0(bc)
  };
}
function writeSpanStatus(bc, x) {
  writeSpanStatusCode(bc, x.code);
  write0(bc, x.message);
}
function readSpanLink(bc) {
  return {
    traceId: readTraceId(bc),
    spanId: readSpanId(bc),
    traceState: read0(bc),
    attributes: readAttributes(bc),
    droppedAttributesCount: bare.readU32(bc)
  };
}
function writeSpanLink(bc, x) {
  writeTraceId(bc, x.traceId);
  writeSpanId(bc, x.spanId);
  write0(bc, x.traceState);
  writeAttributes(bc, x.attributes);
  bare.writeU32(bc, x.droppedAttributesCount);
}
function read1(bc) {
  return bare.readBool(bc) ? readSpanId(bc) : null;
}
function write1(bc, x) {
  bare.writeBool(bc, x !== null);
  if (x !== null) {
    writeSpanId(bc, x);
  }
}
function read2(bc) {
  const len = bare.readUintSafe(bc);
  if (len === 0) {
    return [];
  }
  const result = [readSpanLink(bc)];
  for (let i = 1; i < len; i++) {
    result[i] = readSpanLink(bc);
  }
  return result;
}
function write2(bc, x) {
  bare.writeUintSafe(bc, x.length);
  for (let i = 0; i < x.length; i++) {
    writeSpanLink(bc, x[i]);
  }
}
function readSpanStart(bc) {
  return {
    traceId: readTraceId(bc),
    spanId: readSpanId(bc),
    parentSpanId: read1(bc),
    name: readStringId(bc),
    kind: bare.readU32(bc),
    traceState: read0(bc),
    flags: bare.readU32(bc),
    attributes: readAttributes(bc),
    droppedAttributesCount: bare.readU32(bc),
    links: read2(bc),
    droppedLinksCount: bare.readU32(bc)
  };
}
function writeSpanStart(bc, x) {
  writeTraceId(bc, x.traceId);
  writeSpanId(bc, x.spanId);
  write1(bc, x.parentSpanId);
  writeStringId(bc, x.name);
  bare.writeU32(bc, x.kind);
  write0(bc, x.traceState);
  bare.writeU32(bc, x.flags);
  writeAttributes(bc, x.attributes);
  bare.writeU32(bc, x.droppedAttributesCount);
  write2(bc, x.links);
  bare.writeU32(bc, x.droppedLinksCount);
}
function read3(bc) {
  return bare.readBool(bc) ? readSpanStatus(bc) : null;
}
function write3(bc, x) {
  bare.writeBool(bc, x !== null);
  if (x !== null) {
    writeSpanStatus(bc, x);
  }
}
function readSpanUpdate(bc) {
  return {
    spanId: readSpanId(bc),
    attributes: readAttributes(bc),
    droppedAttributesCount: bare.readU32(bc),
    status: read3(bc)
  };
}
function writeSpanUpdate(bc, x) {
  writeSpanId(bc, x.spanId);
  writeAttributes(bc, x.attributes);
  bare.writeU32(bc, x.droppedAttributesCount);
  write3(bc, x.status);
}
function readSpanEvent(bc) {
  return {
    spanId: readSpanId(bc),
    name: readStringId(bc),
    attributes: readAttributes(bc),
    droppedAttributesCount: bare.readU32(bc)
  };
}
function writeSpanEvent(bc, x) {
  writeSpanId(bc, x.spanId);
  writeStringId(bc, x.name);
  writeAttributes(bc, x.attributes);
  bare.writeU32(bc, x.droppedAttributesCount);
}
function readSpanEnd(bc) {
  return {
    spanId: readSpanId(bc),
    status: read3(bc)
  };
}
function writeSpanEnd(bc, x) {
  writeSpanId(bc, x.spanId);
  write3(bc, x.status);
}
function readSpanSnapshot(bc) {
  return {
    traceId: readTraceId(bc),
    spanId: readSpanId(bc),
    parentSpanId: read1(bc),
    name: readStringId(bc),
    kind: bare.readU32(bc),
    startTimeUnixNs: bare.readU64(bc),
    traceState: read0(bc),
    flags: bare.readU32(bc),
    attributes: readAttributes(bc),
    droppedAttributesCount: bare.readU32(bc),
    links: read2(bc),
    droppedLinksCount: bare.readU32(bc),
    status: read3(bc)
  };
}
function writeSpanSnapshot(bc, x) {
  writeTraceId(bc, x.traceId);
  writeSpanId(bc, x.spanId);
  write1(bc, x.parentSpanId);
  writeStringId(bc, x.name);
  bare.writeU32(bc, x.kind);
  bare.writeU64(bc, x.startTimeUnixNs);
  write0(bc, x.traceState);
  bare.writeU32(bc, x.flags);
  writeAttributes(bc, x.attributes);
  bare.writeU32(bc, x.droppedAttributesCount);
  write2(bc, x.links);
  bare.writeU32(bc, x.droppedLinksCount);
  write3(bc, x.status);
}
function readRecordBody(bc) {
  const offset = bc.offset;
  const tag = bare.readU8(bc);
  switch (tag) {
    case 0:
      return { tag: "SpanStart", val: readSpanStart(bc) };
    case 1:
      return { tag: "SpanEvent", val: readSpanEvent(bc) };
    case 2:
      return { tag: "SpanUpdate", val: readSpanUpdate(bc) };
    case 3:
      return { tag: "SpanEnd", val: readSpanEnd(bc) };
    case 4:
      return { tag: "SpanSnapshot", val: readSpanSnapshot(bc) };
    default: {
      bc.offset = offset;
      throw new bare.BareError(offset, "invalid tag");
    }
  }
}
function writeRecordBody(bc, x) {
  switch (x.tag) {
    case "SpanStart": {
      bare.writeU8(bc, 0);
      writeSpanStart(bc, x.val);
      break;
    }
    case "SpanEvent": {
      bare.writeU8(bc, 1);
      writeSpanEvent(bc, x.val);
      break;
    }
    case "SpanUpdate": {
      bare.writeU8(bc, 2);
      writeSpanUpdate(bc, x.val);
      break;
    }
    case "SpanEnd": {
      bare.writeU8(bc, 3);
      writeSpanEnd(bc, x.val);
      break;
    }
    case "SpanSnapshot": {
      bare.writeU8(bc, 4);
      writeSpanSnapshot(bc, x.val);
      break;
    }
  }
}
function readRecord(bc) {
  return {
    timeOffsetNs: bare.readU64(bc),
    body: readRecordBody(bc)
  };
}
function writeRecord(bc, x) {
  bare.writeU64(bc, x.timeOffsetNs);
  writeRecordBody(bc, x.body);
}
function readSpanRecordKey(bc) {
  return {
    prefix: bare.readU32(bc),
    bucketStartSec: bare.readU64(bc),
    chunkId: bare.readU32(bc),
    recordIndex: bare.readU32(bc)
  };
}
function writeSpanRecordKey(bc, x) {
  bare.writeU32(bc, x.prefix);
  bare.writeU64(bc, x.bucketStartSec);
  bare.writeU32(bc, x.chunkId);
  bare.writeU32(bc, x.recordIndex);
}
function read4(bc) {
  return bare.readBool(bc) ? readSpanRecordKey(bc) : null;
}
function write4(bc, x) {
  bare.writeBool(bc, x !== null);
  if (x !== null) {
    writeSpanRecordKey(bc, x);
  }
}
function readActiveSpanRef(bc) {
  return {
    spanId: readSpanId(bc),
    startKey: readSpanRecordKey(bc),
    latestSnapshotKey: read4(bc)
  };
}
function writeActiveSpanRef(bc, x) {
  writeSpanId(bc, x.spanId);
  writeSpanRecordKey(bc, x.startKey);
  write4(bc, x.latestSnapshotKey);
}
function read5(bc) {
  const len = bare.readUintSafe(bc);
  if (len === 0) {
    return [];
  }
  const result = [bare.readString(bc)];
  for (let i = 1; i < len; i++) {
    result[i] = bare.readString(bc);
  }
  return result;
}
function write5(bc, x) {
  bare.writeUintSafe(bc, x.length);
  for (let i = 0; i < x.length; i++) {
    bare.writeString(bc, x[i]);
  }
}
function read6(bc) {
  const len = bare.readUintSafe(bc);
  if (len === 0) {
    return [];
  }
  const result = [readRecord(bc)];
  for (let i = 1; i < len; i++) {
    result[i] = readRecord(bc);
  }
  return result;
}
function write6(bc, x) {
  bare.writeUintSafe(bc, x.length);
  for (let i = 0; i < x.length; i++) {
    writeRecord(bc, x[i]);
  }
}
function read7(bc) {
  const len = bare.readUintSafe(bc);
  if (len === 0) {
    return [];
  }
  const result = [readActiveSpanRef(bc)];
  for (let i = 1; i < len; i++) {
    result[i] = readActiveSpanRef(bc);
  }
  return result;
}
function write7(bc, x) {
  bare.writeUintSafe(bc, x.length);
  for (let i = 0; i < x.length; i++) {
    writeActiveSpanRef(bc, x[i]);
  }
}
function readChunk(bc) {
  return {
    baseUnixNs: bare.readU64(bc),
    strings: read5(bc),
    records: read6(bc),
    activeSpans: read7(bc)
  };
}
function writeChunk(bc, x) {
  bare.writeU64(bc, x.baseUnixNs);
  write5(bc, x.strings);
  write6(bc, x.records);
  write7(bc, x.activeSpans);
}
function read8(bc) {
  const len = bare.readUintSafe(bc);
  if (len === 0) {
    return [];
  }
  const result = [readChunk(bc)];
  for (let i = 1; i < len; i++) {
    result[i] = readChunk(bc);
  }
  return result;
}
function write8(bc, x) {
  bare.writeUintSafe(bc, x.length);
  for (let i = 0; i < x.length; i++) {
    writeChunk(bc, x[i]);
  }
}
function readReadRangeWire(bc) {
  return {
    startTimeMs: bare.readU64(bc),
    endTimeMs: bare.readU64(bc),
    limit: bare.readU32(bc),
    clamped: bare.readBool(bc),
    baseChunks: read8(bc),
    chunks: read8(bc)
  };
}
function writeReadRangeWire(bc, x) {
  bare.writeU64(bc, x.startTimeMs);
  bare.writeU64(bc, x.endTimeMs);
  bare.writeU32(bc, x.limit);
  bare.writeBool(bc, x.clamped);
  write8(bc, x.baseChunks);
  write8(bc, x.chunks);
}
function encodeReadRangeWire(x) {
  const bc = new bare.ByteCursor(
    new Uint8Array(config.initialBufferLength),
    config
  );
  writeReadRangeWire(bc, x);
  return new Uint8Array(bc.view.buffer, bc.view.byteOffset, bc.offset);
}
function decodeReadRangeWire(bytes) {
  const bc = new bare.ByteCursor(bytes, config);
  const result = readReadRangeWire(bc);
  if (bc.offset < bc.view.byteLength) {
    throw new bare.BareError(bc.offset, "remaining bytes");
  }
  return result;
}

// schemas/versioned.ts
var CURRENT_VERSION = 1;
var CHUNK_VERSIONED = createVersionedDataHandler({
  deserializeVersion: (bytes, version) => {
    switch (version) {
      case 1:
        return decodeChunk(bytes);
      default:
        throw new Error(`Unknown Chunk version ${version}`);
    }
  },
  serializeVersion: (data, version) => {
    switch (version) {
      case 1:
        return encodeChunk(data);
      default:
        throw new Error(`Unknown Chunk version ${version}`);
    }
  },
  deserializeConverters: () => [],
  serializeConverters: () => []
});
var READ_RANGE_VERSIONED = createVersionedDataHandler({
  deserializeVersion: (bytes, version) => {
    switch (version) {
      case 1:
        return decodeReadRangeWire(bytes);
      default:
        throw new Error(`Unknown ReadRangeWire version ${version}`);
    }
  },
  serializeVersion: (data, version) => {
    switch (version) {
      case 1:
        return encodeReadRangeWire(data);
      default:
        throw new Error(`Unknown ReadRangeWire version ${version}`);
    }
  },
  deserializeConverters: () => [],
  serializeConverters: () => []
});
var recordConfig = bare2.Config({});
var chunkConfig = bare2.Config({});
function encodeChunk(chunk) {
  const bc = new bare2.ByteCursor(
    new Uint8Array(chunkConfig.initialBufferLength),
    chunkConfig
  );
  writeChunk(bc, chunk);
  return new Uint8Array(bc.view.buffer, bc.view.byteOffset, bc.offset);
}
function decodeChunk(bytes) {
  const bc = new bare2.ByteCursor(bytes, chunkConfig);
  return readChunk(bc);
}
function encodeRecord(record) {
  const bc = new bare2.ByteCursor(
    new Uint8Array(recordConfig.initialBufferLength),
    recordConfig
  );
  writeRecord(bc, record);
  return new Uint8Array(bc.view.buffer, bc.view.byteOffset, bc.offset);
}

export {
  CURRENT_VERSION,
  CHUNK_VERSIONED,
  READ_RANGE_VERSIONED,
  encodeRecord
};
//# sourceMappingURL=chunk-Z52AMWUL.js.map